var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgTiktok = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 18,
  height: 21,
  fill: "none"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M18.008 8.203c-1.758.04-3.399-.508-4.805-1.523v6.992c0 2.656-1.64 5-4.14 5.937a6.3 6.3 0 0 1-6.993-1.757 6.4 6.4 0 0 1-.82-7.227C2.5 8.32 5.078 7.031 7.734 7.383v3.515a2.95 2.95 0 0 0-3.28 1.055c-.704 1.055-.704 2.422.038 3.438.742 1.015 2.07 1.445 3.242 1.054a2.93 2.93 0 0 0 2.032-2.773V0h3.437c0 .313 0 .586.078.898a4.62 4.62 0 0 0 2.11 3.125c.742.508 1.68.782 2.617.782z"
})));
export default SvgTiktok;